import React, { useState, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";
import { useTheme } from "../../../hooks/ThemeProvider";

const PoolFilters = ({ onFilterChange }) => {
  const { theme } = useTheme();
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("");

  const sortOptions = [
    // { label: "Name Ascending", value: "name_asc" },
    // { label: "Name Descending", value: "name_desc" },
    // { label: "APR", value: "apr" },
    // { label: "TVL", value: "tvl" },
    // { label: "Lock Options", value: "lock" },
    { label: "Creator Fee Ascending", value: "creatorFeePercent@ASC" },
    { label: "Creator Fee Descending", value: "creatorFeePercent@DESC" },
  ];

  // ✅ Debounce search input (500ms)
  useEffect(() => {
    const handler = setTimeout(() => {
      if (onFilterChange) {
        onFilterChange({ search, sortBy });
      }
    }, 500);

    return () => clearTimeout(handler);
  }, [search, sortBy, onFilterChange]);

  // ✅ Handle sort change immediately
  const handleSortChange = (value) => {
    setSortBy(value);
    if (onFilterChange) {
      onFilterChange({ search, sortBy: value });
    }
  };

  return (
    <>
      <div className="innner_topp">
        <h3>Explore Active Pools</h3>
        <div className="search_Side">
          {/* <div className="inner_Search">
            <img src="\assets\searchicon.svg" className="searchicon" alt="Search" />
            <input
              placeholder="Search by wallet address"
              type="text"
              id="fname"
              name="fname"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div> */}
          <Dropdown>
            <Dropdown.Toggle variant="success" id="dropdown-basic">
              Sort by{" "}
              <span>
                {sortOptions.find((o) => o.value === sortBy)?.label}
              </span>
              <div>
                {
                  theme === 'dark' ? <img src="\assets\droparrow.svg" className="dropsvg" alt="Arrow" />
                    : <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M3 4.5L6 7.5L9 4.5" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                }

              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {sortOptions.map((option, index) => (
                <Dropdown.Item
                  key={index}
                  onClick={() => handleSortChange(option.value)}
                >
                  <div className="drop_inside">
                    <h5>
                      Sort by: <span>{option.label}</span>
                    </h5>
                    {sortBy === option.value && (
                      <img src="\assets\bluetick.svg" alt="Selected" />
                    )}
                  </div>
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>


          <Link to="/childpool">
            <button>
              {
                theme === 'dark' ? <img src="\assets\plus.svg" alt="Plus" />
                  : <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M2.91699 7H11.0837" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7 2.91669V11.0834" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
              }

              Create Child Pool
            </button>
          </Link>
        </div>
      </div>

      <Link to="/childpool">
        <div className="mobilebuttonmain">
          <div className="innermbl d-none">
            <button>
              {
                theme === 'dark' ? <img src="\assets\plus.svg" alt="Plus" />
                  : <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M2.91699 7H11.0837" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7 2.91669V11.0834" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
              }
              Create Child Pool
            </button>
          </div>
        </div>
      </Link>
    </>
  );
};

export default PoolFilters;